import AdminLayout from "../../../components/admin/layout/AdminLayout";
import AdminWorkerRequestTable from "../../../components/admin/billing/AdminWorkerRequestTable";
import AdminBillingTable from "../../../components/admin/billing/AdminBillingTable";
import AdminTaxInvoiceTable from "../../../components/admin/billing/AdminTaxInvoiceTable";
import AdminRegularTaxInvoiceTable from "../../../components/admin/billing/AdminRegularTaxInvoiceTable";
//어드민 결제 메인 페이지
const AdminBillingMainPage: React.FC = () => {
    return (
        <AdminLayout>
            {/*어드민 결제 테이블*/}
            <AdminBillingTable/>
            {/*어드민 작업자 추가 요청 테이블*/}
            <AdminWorkerRequestTable/>
            {/*어드민 세금계산서 테이블*/}
            <AdminTaxInvoiceTable/>
            {/*어드민 세금게산선 정기발행 테이블*/}
            <AdminRegularTaxInvoiceTable/>
        </AdminLayout>
    )
}
export default AdminBillingMainPage;